import React, { useEffect, useRef, useState } from 'react';
import { campaignDate, percentage, trendCampaigns } from './overviewData';

export default function OverviewTrend({ campaigns, locale, formatRate, t }) {
  const container = useRef(null);
  const [width, setWidth] = useState(600);
  useEffect(() => {
    const measure = () => {
      const value = container.current?.getBoundingClientRect().width;
      if (value) setWidth(Math.max(220, Math.round(value)));
    };
    measure();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    observer?.observe(container.current);
    window.addEventListener('resize', measure);
    return () => { observer?.disconnect(); window.removeEventListener('resize', measure); };
  }, []);
  const items = trendCampaigns(campaigns);
  const totalWithSends = campaigns.filter(item => item.stats.sent > 0 && campaignDate(item.launch_date)).length;
  const dateFormat = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
  const numberFormat = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 });
  const height = 219, left = 34, right = 20, top = 15, bottom = 35;
  const max = Math.ceil(Math.max(20, ...items.map(item => percentage(item.stats.clicked, item.stats.sent))) / 5) * 5;
  const y = value => height - bottom - value / max * (height - top - bottom);
  const points = items.map((item, index) => ({ item,
    x: items.length === 1 ? (width + left - right) / 2 : left + index * (width - left - right) / (items.length - 1),
    y: y(percentage(item.stats.clicked, item.stats.sent)) }));
  const line = points.map(point => `${point.x},${point.y}`).join(' ');
  const labelStep = Math.max(1, Math.ceil(items.length / (width < 380 ? 4 : 7)));
  return <>
    <div className="overview-trend" ref={container}>
      {!items.length ? <p className="overview-chart-empty">{t('phishing_overview.chart_empty')}</p> :
        <svg viewBox={`0 0 ${width} ${height}`} role="img" aria-label={t('phishing_overview.chart_accessible')}>
          <title>{t('phishing_overview.trend_title')}</title>
          {[0, 1, 2, 3, 4].map(index => {
            const value = max / 4 * index, py = y(value);
            return <g key={index}><line x1={left} x2={width - right} y1={py} y2={py} stroke="#edf0f2" strokeDasharray="3 5" />
              <text x={left - 8} y={py + 3} textAnchor="end" fill="#8b969f" fontSize="10">{numberFormat.format(value)}%</text></g>;
          })}
          <polygon points={`${points[0].x},${height - bottom} ${line} ${points[points.length - 1].x},${height - bottom}`} fill="#76a96c" fillOpacity=".055" />
          <polyline points={line} fill="none" stroke="#76a96c" strokeWidth="2" strokeLinejoin="round" />
          {points.map(({ item, x, y: py }, index) => <g key={item.id}>
            <circle cx={x} cy={py} r="3.5" fill="#fff" stroke="#76a96c" strokeWidth="1.7" tabIndex="0"
              aria-label={`${item.name}: ${formatRate(item.stats.clicked, item.stats.sent)}`}>
              <title>{item.name}: {formatRate(item.stats.clicked, item.stats.sent)} ({item.stats.clicked}/{item.stats.sent})</title>
            </circle>
            {(index % labelStep === 0 || index === items.length - 1) && <text x={x} y={height - 13} textAnchor="middle" fontSize="10" fill="#8b969f">{dateFormat.format(campaignDate(item.launch_date))}</text>}
          </g>)}
        </svg>}
    </div>
    <p className="overview-footnote">{t('phishing_overview.trend_note')}
      {totalWithSends > items.length && <> {t('phishing_overview.chart_limited', { count: items.length })}</>}
    </p>
  </>;
}
